import * as c from '../constants';
import { isWaiting } from '../../Action';

export const onGetPaymentPostback = (bool) => ({
    type: c.GET_PAYMENT_POSTBACK,
    bool
})

export const onGetPayments = (data) => ({
    type: c.GET_PAYMENT_LISTS,
    data
})


export const getPaymentPostback = (data) => {
    return (dispatch, getState, { api, history, alert }) => {
        dispatch(isWaiting(true));
        api.post(`inquiry/postback`, data, dispatch)
            .then(res => {
                dispatch(isWaiting(false));
                if(!res) return;
                alert.success(res.data.message)
                dispatch(onGetPaymentPostback(true));
                dispatch(onGetPayments({}));
            })
    }
}

export const getPayments = (data) => {
    return (dispatch, getState, { api, history, alert }) => {
        dispatch(isWaiting(true));
        api.post(`inquiry`, data, dispatch)
            .then(res => {
                dispatch(isWaiting(false));
                if(!res) return;
                dispatch(onGetPayments(res.data));
                dispatch(onGetPaymentPostback(false));
            })
    }
}


/** WEBPACK FOOTER **
 ** ./src/payment/actions/index.js
 **/